import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

interface Props {
    color?: string
}

export const ArticleMetadataParagraph = styled.p<Props>`
    ${cssMediaQueryBreakpoints.small} {
        font-size: 10px;
    }

    font-size: 12px;
    font-weight: 400;
    color: ${p => p.color || p.theme.textColor};
`
